import { createContext } from "react";

export const SrpContext = createContext({
  mobileFiltersOpen: false,
  setMobileFiltersOpen() {},
  mapOpen: false,
  setMapOpen() {},
});

export const FilterContext = createContext({
  errors: {},
  setErrors() {},
  activeFilter: null,
  setActiveFilter() {},
});
